import React, { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Center, Spinner } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';

interface RequireSubscriptionProps {
  children: ReactNode;
}

export const RequireSubscription: React.FC<RequireSubscriptionProps> = ({ children }) => {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      window.location.replace('/');
    }
  }, [loading, user]);

  if (loading || !user) {
    return (
      <Center h="200px">
        <Spinner size="lg" color="var(--accent)" />
      </Center>
    );
  }

  if (!user.is_subscribed) {
    return <Navigate to="/subscription" replace />;
  }

  return <>{children}</>;
};
